import classes from '../DashboardItem.module.css'

import DashboardViewAll from '../../DashboardViewAll';
// import InfoButton from '../../InfoButton';
import TranfersList from './TranfersList';
import { useGetTransfersListDashboard } from '../../../../lib/hooks';
import WidgetSummary from '../WidgetSummary';

export default function TransfersWidget() {
    const PER_PAGE = 5
    useGetTransfersListDashboard(PER_PAGE)


    return <div className={`${classes.item_inner}`}>
        <div className={classes.item_header}>
            <div>
                <div className={classes.item_title}>
                    Transfers
                    {/* <InfoButton info={'different info to know that this is different'}/> */}
                </div>

                <WidgetSummary perPage={PER_PAGE} widgetType={'transfers'}/>
            </div>
            <DashboardViewAll urlPage={'/transfers'}/>
        </div>
        <div className={classes.item_body}>
            <div className={classes.container}>
                <table className='table-border-radius-8'>
                    <thead>
                        <tr>
                            <th>NG #</th>
                            <th>Patient Name</th>
                            <th>From</th>
                            <th>To</th>
                            <th>Status</th>
                            <th>Reason</th>
                            <th>Date of First Appointment</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <TranfersList />
                    </tbody>
                </table>
            </div>
        </div>
    </div>
}